import { addMoney, compareMoney, type CurrencyCode, zeroMoney } from '@taler/domain'
import type { CategorySpend } from './types.ts'

const MAX_ROWS = 5

/**
 * The largest categories on Home. Past the limit the top four stay named and everything else,
 * unassigned items included, folds into one final "Other" row, so the visible rows always
 * add up to the headline total.
 */
export function visibleCategoryRows(
  items: readonly CategorySpend[],
  currency: CurrencyCode,
): readonly CategorySpend[] {
  const named = items
    .filter((item) => item.accountId !== undefined)
    .sort((a, b) => compareMoney(b.amount, a.amount))
  const unassigned = items.filter((item) => item.accountId === undefined)
  const fits = named.length + (unassigned.length > 0 ? 1 : 0) <= MAX_ROWS
  const shown = fits ? named : named.slice(0, MAX_ROWS - 1)
  const folded = [...(fits ? [] : named.slice(MAX_ROWS - 1)), ...unassigned]
  if (folded.length === 0) return shown
  const other: CategorySpend = {
    accountId: undefined,
    amount: folded.reduce((sum, item) => addMoney(sum, item.amount), zeroMoney(currency)),
    entryCount: folded.reduce((sum, item) => sum + item.entryCount, 0),
    share: undefined,
  }
  return [...shown, other]
}
